var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticStyle:{"height":"30px"},attrs:{"size":"small","icon":"md-close-circle","type":"default"},on:{"click":function($event){return _vm.$emit('on-click')}}},[_vm._v("取消")])}
var staticRenderFns = []

export { render, staticRenderFns }